export const THUMBNAILS_CACHE_CONTROL = 'private, max-age=0'
